import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, BubbleSelectBlock, Text, TextInput, Checkbox, Services, NumberInput, DateInput } from '@simplybenefits/sb-ui-library';
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

class MetaClaimInputModal extends PureComponent {
    state = {
        patient: this.props.meta ? this.props.meta.patient : '',
        category: this.props.meta ? this.props.meta.category : this.props.type === 'Lifestyle Spending' ? 'Lifestyle Spending' : '',
        service: '',
        amountSubmitted: this.props.meta && !isNaN(parseInt(this.props.meta.amountSubmitted, 10)) ? `${ Number(this.props.meta.amountSubmitted).toFixed(2) }` : '',
        serviceDate: (this.props.meta && this.props.meta.serviceDate) ? Services.dates.formatIncomingDate(this.props.meta.serviceDate) : null,
        provider: this.props.meta && this.props.meta.provider ? this.props.meta.provider : null,
        serviceOptions: [],
        patientOptions: [],
        acceptedHSATerms: false,
        acceptedHSATermsError: false,
        cert: this.props.meta ? this.props.meta.cert : '',
        loadedCert: '',
        autoTopOff: this.props.meta ? this.props.meta.autoTopOff : null
    };

    static getDerivedStateFromProps(props, state) {
        if (props.claimTypes && props.userData && state.loadedCert !== props.userData.meta.cert) {
            const dependents = props.userData.dependents.map((dependent) => ({
                name: `${ dependent.firstname } ${ dependent.lastname } (${ dependent.relationship })`,
                id: dependent.dependentID
            }));

            const primary = {
                name: `${ props.userData.meta.firstname } ${ props.userData.meta.lastname }`,
                id: props.userData.meta.userID
            };

            let newPatientOptions = [ primary, ...dependents ];

            const serviceOptions = props.type === 'Lifestyle Spending' ? props.claimTypes['Lifestyle Spending'].reverse() : props.claimTypes.Paramedicals.reverse();

            // if the member is under Survivor Benefit status then ensure we add a way to claim for the deceased primary cert
            if (props.userData.meta.status === 11) {
                const deceasedPrimary = {
                    name: 'Deceased Primary Cert',
                    id: props.userData.meta.userID
                };

                newPatientOptions = [ deceasedPrimary, ...dependents ];
            }

            return {
                patientOptions: newPatientOptions,
                serviceOptions,
                category: props.type === 'Lifestyle Spending' ? 'Lifestyle Spending' : 'Paramedicals',
                patient: newPatientOptions[0],
                service: serviceOptions[0],
                loadedCert: props.userData.meta.cert,
                cert: props.userData.meta.cert,
                autoTopOff: null
            };
        }

        return null;
    }

    _selectPatient = async (event) => {
        await this.setState({
            patient: this.state.patientOptions.find((e) => e.name === event.target.value)
        });

        this._saveData();
    };

    _selectCategory = async (event) => {
        await this.setState({
            category: event.target.value
        });

        this._setServiceOptions(event.target.value);
        this._saveData();
    };

    _selectService = async (event) => {
        await this.setState({
            service: event.target.value
        });

        this._saveData();
    };

    _handleInputChange = async (type, value) => {
        await this.setState({
            [type]: value
        });

        this._saveData();
    };


    _handleTermsChange = () => {
        this.setState({
            acceptedHSATerms: !this.state.acceptedHSATerms
        });
    };

    _saveData = () => {
        this.props.saveData({
            ...this.props.meta,
            patient: this.state.patient,
            category: this.state.category,
            service: this.state.service,
            amountSubmitted: this.state.amountSubmitted,
            serviceDate: this.state.serviceDate,
            provider: this.state.provider,
            cert: this.state.cert,
            autoTopOff: this.state.autoTopOff
        }, 'meta');
    };

    _next = async () => {
        const amountSubmittedError = await Services.validateInput('checkEmpty', this.state.amountSubmitted);
        const serviceDateError = await Services.validateInput('date', this.state.serviceDate, 'en');

        this.setState({
            amountSubmittedError,
            serviceDateError
        });

        if (amountSubmittedError || serviceDateError) {
            return null;
        }

        if (this.props.type === 'HealthSpending' && !this.state.acceptedHSATerms) {
            this.setState({
                acceptedHSATermsError: 'You must first submit any claims via the Claims section before submitting to your Health Spending account.'
            });

            return null;
        }

        await this._saveData();
        this.props.next();
        return null;
    };

    _setServiceOptions = (category) => {
        const options = this.props.type === 'Lifestyle Spending' ? this.props.claimTypes['Lifestyle Spending'].reverse() : this.props.claimTypes[category].reverse();

        this.setState({
            serviceOptions: options,
            service: options[0]
        });
    };

    _getPrimaryButton = () => {
        if (!this.state.loadedCert || this.state.loadedCert !== this.state.cert) {
            return {
                label: "Load Member",
                onClick: () => this.props.getCertInfo(this.state.cert)
            };
        }

        return {
            label: "Next",
            onClick: this._next
        };
    };

    render() {
        const categoryOptions = [
            'Drugs',
            'Health',
            'Paramedicals',
            'Vision'
        ];

        if (this.props.type.toUpperCase() !== 'STANDARD') {
            categoryOptions.push('Dental');
        }

        return (
            <Modal
                medium={ this.state.loadedCert }
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={ this._getPrimaryButton() }
                onClose={ this.props.onClose}
                loader={ this.props.loader }
            >
                <Text medium margin="10px 0">
                    Certificate:
                </Text>

                <TextInput
                    label="Certificate"
                    variant="outlined"
                    value={this.state.cert}
                    margin="0"
                    onChange={(e) => {
                        this.setState({
                            cert: e.target.value
                        });
                    }}
                    required
                    fullWidth
                    disabled={this.state.loadedCert}
                />

                {
                    this.state.loadedCert &&
                            <React.Fragment>
                                {
                                    this.props.type === 'Standard' &&
                                        <React.Fragment>
                                            <Text small margin="10px 0 0 0">
                                                Automatically use any available Health Spending balance for Top Off?
                                            </Text>

                                            <BubbleSelectBlock
                                                first={{
                                                    title: 'Yes',
                                                    selected: this.state.autoTopOff === true,
                                                    field: true
                                                }}
                                                second={{
                                                    title: 'No',
                                                    selected: this.state.autoTopOff === false,
                                                    field: false
                                                }}
                                                handleChange={ (field) => this.setState({ autoTopOff: field }) }
                                            />
                                        </React.Fragment>
                                }

                                <Text medium margin="10px 0">
                                    Patient:
                                </Text>

                                <TextInput
                                    label="Select Patient"
                                    variant="outlined"
                                    value={this.state.patient.name}
                                    onChange={this._selectPatient}
                                    select
                                    required
                                    fullWidth
                                    selectOptions={this.state.patientOptions.map((e) => e.name)}
                                    margin="0"
                                />

                                {
                                    this.props.type === 'Lifestyle Spending' ?
                                        <React.Fragment>
                                            <Text mediumLarge margin="10px 0">
                                                Category:
                                            </Text>

                                            <TextInput
                                                label="Select Category"
                                                variant="outlined"
                                                value={this.state.service}
                                                onChange={this._selectService}
                                                select
                                                required
                                                fullWidth
                                                selectOptions={ this.state.serviceOptions }
                                                margin="0"
                                            />
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <Text medium margin="10px 0">
                                                Category:
                                            </Text>

                                            <TextInput
                                                label="Select Category"
                                                variant="outlined"
                                                value={this.state.category}
                                                onChange={this._selectCategory}
                                                select
                                                required
                                                fullWidth
                                                selectOptions={ categoryOptions }
                                                margin="0"
                                            />

                                            <Text medium margin="10px 0">
                                                Service:
                                            </Text>

                                            <TextInput
                                                label="Select Service"
                                                variant="outlined"
                                                value={this.state.service}
                                                onChange={this._selectService}
                                                select
                                                required
                                                fullWidth
                                                selectOptions={ this.state.serviceOptions }
                                                margin="0"
                                            />
                                        </React.Fragment>
                                }

                                <Text medium margin="5px 0 -5px 0">
                                    Service Date:
                                </Text>

                                <DateInput
                                    label="Service Date"
                                    value={ this.state.serviceDate || ''}
                                    onChange={(e) => this._handleInputChange('serviceDate', e.target.value)}
                                    error={Boolean(this.state.serviceDateError)}
                                    helperText={this.state.serviceDateError}
                                    fullWidth
                                    required
                                    testid="dateinput"
                                    variant={"outlined"}
                                />

                                <Text medium margin="5px 0 -5px 0">
                                    Amount Paid:
                                </Text>

                                <NumberInput
                                    prefix="$"
                                    label="Amount"
                                    value={ this.state.amountSubmitted }
                                    onChange={(e) => this._handleInputChange('amountSubmitted', e.target.value)}
                                    error={Boolean(this.state.amountSubmittedError)}
                                    helperText={this.state.amountSubmittedError}
                                    fullWidth
                                    required
                                    testid="amountsubmitted"
                                    variant={"outlined"}
                                />

                                {
                                    this.props.type === 'Health Spending' &&
                                    <FormControl error={ Boolean(this.state.acceptedHSATermsError) }>
                                        <FormGroup
                                            row
                                            style={{ marginTop: 20 }}
                                        >
                                            <FormControlLabel
                                                style={{ margin: 0 }}
                                                control={
                                                    <Checkbox
                                                        checked={ this.state.acceptedHSATerms }
                                                        onChange={ this._handleTermsChange }
                                                        value="acceptedHSATerms"
                                                        color="secondary"
                                                    />
                                                }
                                                label="I hereby acknowledge that I have already submitted this claim via the Claim section of Simply Benefits. Any provided receipts were provided by Simply Benefits or another insurance provider after submitting the original claim."
                                            />
                                        </FormGroup>

                                        {
                                            this.state.acceptedHSATermsError &&
                                            <FormHelperText>{ this.state.acceptedHSATermsError }</FormHelperText>
                                        }
                                    </FormControl>
                                }
                            </React.Fragment>
                }

                <Text 
                    light 
                    tiny 
                    customStyle={{ marginTop: 10 }}
                >
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>
            </Modal>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    claimTypes: state.adjudication.claimTypes
});

export default connect(mapStateToProps)(MetaClaimInputModal);